export class GdsgEnvironment {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "objectExplorerEnabled",
            "baseName": "objectExplorerEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "scanningGcpProjectId",
            "baseName": "scanningGcpProjectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "dataPlaneServiceAccountEmail",
            "baseName": "dataPlaneServiceAccountEmail",
            "type": "string",
            "format": ""
        },
        {
            "name": "replicationSlaSeconds",
            "baseName": "replicationSlaSeconds",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "consolidationSlaSeconds",
            "baseName": "consolidationSlaSeconds",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "lastProvisionedPulumiVersion",
            "baseName": "lastProvisionedPulumiVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "customerDomains",
            "baseName": "customerDomains",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "bucketNames",
            "baseName": "bucketNames",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "regions",
            "baseName": "regions",
            "type": "Array<GdsgEnvironmentRegion>",
            "format": ""
        },
        {
            "name": "productionTieringPolicyId",
            "baseName": "productionTieringPolicyId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "backupTieringPolicyId",
            "baseName": "backupTieringPolicyId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "productionTieringPolicy",
            "baseName": "productionTieringPolicy",
            "type": "VaultTieringPolicy",
            "format": ""
        },
        {
            "name": "backupTieringPolicy",
            "baseName": "backupTieringPolicy",
            "type": "VaultTieringPolicy",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GdsgEnvironment.attributeTypeMap;
    }
    constructor() {
    }
}
